import * as License from "@luciad/ria/util/License.js";

//  tslint:disable-next-line:no-var-requires
const licenseText = require("./license/luciadria-license.txt");
License.setLicenseText(licenseText);